import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
.use(HttpApi) // Load translations from external files
.use(LanguageDetector) // Detect browser language
.use(initReactI18next) // Bind to React
.init({
  supportedLngs: ["en", "ru", "ar", "pt", "es", "fr", "ko"], // Supported languages
  fallbackLng: "en", // Default language
  detection: {
    order: ["cookie", "localStorage", "navigator", "htmlTag"],
    caches: ["cookie", "localStorage"],
  },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json" // Path to translation files
    },
    interpolation: {
      escapeValue: false, // React already does escaping
    },
  });

export default i18n;
